import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export const buttonVariants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  destructive: 'btn-destructive',
  destructiveOutline: 'btn-destructive-outline',
} as const;

export type ButtonVariant = keyof typeof buttonVariants;

export const buttonSizes = {
  sm:   'px-3 py-1.5 text-xs',
  md:   '',
  lg:   'px-5 py-2.5 text-base',
  icon: 'h-9 w-9 p-0 grid place-items-center',
} as const;

export type ButtonSize = keyof typeof buttonSizes;

export function buttonClassName(variant: ButtonVariant = 'primary', className?: string) {
  return cn(buttonVariants[variant], className);
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(buttonVariants[variant], buttonSizes[size], className)}
      {...props}
    />
  ),
);
Button.displayName = 'Button';
